import { normalizeCropCode } from "pages/admin/experiments/cropExtraction/cropCodes";
import { findField, findTable, runDbfParser, toNumber, toString } from "pages/admin/experiments/cropExtraction/parsers/genericDbf";
import { ParserResult } from "pages/admin/experiments/cropExtraction/types";

export const parseDianaweb = (zipBuffer: ArrayBuffer): Promise<ParserResult> =>
  runDbfParser(zipBuffer, {
    notFoundMessage: "Schlaege_*.dbf not found or empty",
    pickTable: (tables) => findTable(tables, (b) => /^schlaege_/.test(b) && !b.endsWith("_teilflaechen")),
    buildExtractor: (table) => {
      // The Schlaege DBF stores the main crop NC as `SC_HA_CODE`
      // ("Schlag-Hauptanbau-Code"), which equals the NC of the
      // HAUPTNUTZUNGSFLAECHE row in the sibling _teilflaechen DBF.
      // `ERZCODE` is the Bundesland code (e.g. "SN" for every Sachsen
      // record) — NOT a crop code — so it must not appear here.
      const cropCol = findField(table.rows, ["SC_HA_CODE", "NC", "nutz_code"]);
      const fieldNameCol = findField(table.rows, ["SCHLAG_BEZ", "FB_BEZEICH", "lage_bez", "schlagbez", "BEZEICHNUNG"]);
      const fieldIdCol = findField(table.rows, ["SCHLAG_ID", "EXCHANGE_I", "FID", "schlagnr_a", "schlagnr"]);
      const areaCol = findField(table.rows, ["SC_FL_BRUT", "SC_FLAE_GI", "beantr_gro", "Flaeche", "flaeche_ha"]);

      return (row) => {
        const fieldId = fieldIdCol ? toString(row[fieldIdCol]) : "";
        const fieldName = (fieldNameCol && toString(row[fieldNameCol])) || fieldId;
        return {
          fieldId,
          fieldName,
          cropCode: normalizeCropCode(cropCol ? toString(row[cropCol]) : ""),
          cropDescription: "",
          areaHa: areaCol ? toNumber(row[areaCol]) : 0,
          fieldNumber: fieldId || undefined,
        };
      };
    },
  });
